var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4ccace;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.375,3.375a13,13,0,1,0,13,13A13,13,0,0,0,16.375,3.375Zm6.656,9.406-8.356,8.394h-.006a1.129,1.129,0,0,1-.725.344,1.094,1.094,0,0,1-.731-.356l-3.5-3.5a.249.249,0,0,1,0-.356l1.112-1.112a.242.242,0,0,1,.35,0l2.775,2.775,7.625-7.681a.247.247,0,0,1,.175-.075h0a.227.227,0,0,1,.175.075l1.094,1.131A.246.246,0,0,1,23.031,12.781Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.92637cb2bb5327d5007868acfa1f7a3f.svg";
export { ForwardRef as ReactComponent };